import type { ExplicitAddress } from '@cronos-app/sdk';
import { useDesiredChain } from '@cronos-app/wallet';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { Token } from '@ui/config/token';
import { useSDK } from '@ui/utils';
import type { Fraction } from 'bi-fraction';

import { fetchTokenPrice } from '../tokenPrice/fetchers/priceFetchers';
import { useGlobalChainLayer } from '../useGlobalChainLayer';

export const useAgentfunRemaining = (
  bondingPairAddress: ExplicitAddress,
): UseQueryResult<{
  agentfunRemaining: Fraction;
  agentfunDeposited: Fraction;
  bondingRemaining: Fraction;
  mcapUsdAtGraduation: Fraction;
}> => {
  const sdk = useSDK();
  const chainLayer = useGlobalChainLayer();
  const chainId = useDesiredChain(chainLayer);

  return useQuery({
    queryKey: [useAgentfunRemaining.queryKey, bondingPairAddress, chainId],
    queryFn: async () => {
      const bondingCurveModule = sdk.getBondingCurveModule();
      const [results, agentfunPrice] = await Promise.all([
        bondingCurveModule.getRemainingAgentfunAmount(bondingPairAddress),
        fetchTokenPrice(Token.agentFun, chainId),
      ]);

      return {
        ...results,
        mcapUsdAtGraduation: results.mcapAtGraduation.mul(
          agentfunPrice.usd_price,
        ),
      };
    },
    enabled: !!bondingPairAddress,
  });
};
useAgentfunRemaining.queryKey = 'useAgentfunRemaining';
